import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

import { Provider } from "react-redux";
import { combineReducers, createStore } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import storage from "redux-persist/lib/storage";
import user_auth from "./store/reducers/userReducer";
import shoppingCartReducer from "./store/reducers/shoppingCartReducer";
import recommendedProduct from "./store/reducers/recommendedReducer";
import sendCostReducer from "./store/reducers/sendCostReducer";
import showNavUserReducer from "./store/reducers/showNavUserReducer";
import showNavReducer from "./store/reducers/showNavReducer";

const rootReducer = combineReducers({
  user_auth,
  shoppingCart: shoppingCartReducer,
  recommendedProduct,
  sendCost: sendCostReducer,
  showNavUser: showNavUserReducer,
  showNav: showNavReducer,
});

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(
  persistedReducer,
  {},
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
);

const persistor = persistStore(store);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById("root"),
);
